import React from 'react';

export function ErrorAlert({ message }: { message: string }) {
	if (!message) return null;
	return (
		<div role="alert" className="rounded-xl border border-red-200 bg-red-50 text-red-800 px-4 py-3 text-sm">
			{message}
		</div>
	);
} 